import { useState, useEffect } from "react";
import Modal from "react-modal";
import FloatingMenu from "../../componente/menuflutuante";
import "./style.css";
import api from "../../services/api";
import Aguarde from "../../../src/componente/aguarde/index.jsx";

Modal.setAppElement("#root");

export default function Estoque() {
  const [tipoUsuario, setTipoUsuario] = useState(
    localStorage.getItem("tempTipo")
  );

  const [estoque, setEstoque] = useState([]);
  const [modalTransferir, setModalTransferir] = useState(false);
  const [modalDevolver, setModalDevolver] = useState(false);
  const [loading, setLoading] = useState(false);

  const [buscaProduto, setBuscaProduto] = useState("");

  // Agora armazenamos vários produtos selecionados
  const [itens, setItens] = useState([]);

  const [vendedores, setVendedores] = useState([]);
  const [buscaVendedor, setBuscaVendedor] = useState("");
  const [vendedorSel, setVendedorSel] = useState(null);

  const fetchDataVendedores = async () => {
    try {
      setLoading(true);

      const response = await api.get("v1/estoque/vendedores", {
        params: {
          codequipe: localStorage.getItem("tempCodEquipe"),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setVendedores(response.data);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataEstoque = async () => {
    try {
      setLoading(true);

      const response = await api.get("v1/estoque/estoque", {
        params: {
          tipo: tipoUsuario,
          codigo:
            tipoUsuario === "E"
              ? localStorage.getItem("tempCodEquipe")
              : localStorage.getItem("tempCodFuncionario"),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setEstoque(response.data);
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataEstoque();
    setTipoUsuario(localStorage.getItem("tempTipo"));
  }, []);

  function abrirModal(tipo) {
    try {
      setLoading(true);

      // Limpa os produtos selecionados
      setItens([]);
      setBuscaProduto("");

      setVendedorSel(null);
      setBuscaVendedor("");

      if (tipo === "transferir") {
        setModalTransferir(true);
        fetchDataVendedores();
      } else {
        setModalDevolver(true);
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
    } finally {
      setLoading(false);
    }
  }

  /**
   * Retorna quanto ainda está disponível para um produto.
   *
   * Se o produto já estiver selecionado, descontamos a quantidade
   * que já foi informada.
   */
  function estoqueDisponivel(produto) {
    const itemLancado = itens.find(
      (i) => i.codproduto === produto.codproduto
    );

    return itemLancado
      ? produto.estoque - itemLancado.qtd
      : produto.estoque;
  }

  /**
   * Verifica se o produto está selecionado.
   */
  function produtoSelecionado(codproduto) {
    return itens.some((i) => i.codproduto === codproduto);
  }

  /**
   * Seleciona ou desmarca um produto.
   *
   * Ao marcar:
   * - adiciona o produto no array
   * - começa com quantidade 1
   *
   * Ao desmarcar:
   * - remove o produto do array
   */
  function alternarProduto(produto) {
    const jaSelecionado = produtoSelecionado(produto.codproduto);

    if (jaSelecionado) {
      setItens((lista) =>
        lista.filter((i) => i.codproduto !== produto.codproduto)
      );
      return;
    }

    // Não permite selecionar produto sem estoque
    if (produto.estoque <= 0) {
      alert(`O produto "${produto.descricao}" não possui estoque disponível.`);
      return;
    }

    setItens((lista) => [
      ...lista,
      {
        ...produto,
        qtd: 0,
      },
    ]);
  }

  /**
   * Altera a quantidade de um produto já selecionado.
   */
  function alterarQuantidade(codproduto, novaQuantidade) {
    let qtd = Number(novaQuantidade);

    if (!Number.isFinite(qtd)) {
      qtd = 1;
    }

    qtd = Math.floor(qtd);

    if (qtd < 0) {
      qtd = 0;
    }

    const produto = estoque.find(
      (p) => p.codproduto === codproduto
    );

    if (!produto) return;

    /*if (qtd > produto.estoque) {
      qtd = produto.estoque;

      alert(
        `A quantidade máxima disponível para "${produto.descricao}" é ${produto.estoque}.`
      );
    }*/

    setItens((lista) =>
      lista.map((item) =>
        item.codproduto === codproduto
          ? {
              ...item,
              qtd,
            }
          : item
      )
    );
  }

  /**
   * Remove um produto dos selecionados.
   */
  function removerItem(codproduto) {
    setItens((lista) =>
      lista.filter((i) => i.codproduto !== codproduto)
    );
  }

  /**
   * Remove todos os produtos selecionados.
   */
  function limparProdutos() {
    setItens([]);
  }

  /**
   * Seleciona todos os produtos que estão aparecendo na busca.
   */
  function selecionarTodosResultados() {
    const produtosFiltrados = estoque.filter((p) =>
      p.descricao
        ?.toLowerCase()
        .includes(buscaProduto.toLowerCase())
    );

    const produtosDisponiveis = produtosFiltrados.filter(
      (p) => p.estoque > 0
    );

    setItens((listaAtual) => {
      const novaLista = [...listaAtual];

      produtosDisponiveis.forEach((produto) => {
        const existe = novaLista.some(
          (item) => item.codproduto === produto.codproduto
        );

        if (!existe) {
          novaLista.push({
            ...produto,
            qtd: 1,
          });
        }
      });

      return novaLista;
    });
  }

  /**
   * Seleciona todos os produtos encontrados usando a quantidade total disponível.
   * Essa opção é usada para facilitar a devolução completa para a empresa.
   */
  function selecionarTodosParaDevolucaoTotal() {
    const produtosFiltrados = estoque.filter((p) =>
      p.descricao
        ?.toLowerCase()
        .includes(buscaProduto.toLowerCase())
    );

    const produtosDisponiveis = produtosFiltrados.filter(
      (p) => Number(p.estoque) > 0
    );

    setItens((listaAtual) => {
      const novaLista = [...listaAtual];

      produtosDisponiveis.forEach((produto) => {
        const indice = novaLista.findIndex(
          (item) => item.codproduto === produto.codproduto
        );

        if (indice >= 0) {
          // Se já estiver selecionado, atualiza para todo o estoque disponível.
          novaLista[indice] = {
            ...novaLista[indice],
            ...produto,
            qtd: Number(produto.estoque),
          };
        } else {
          novaLista.push({
            ...produto,
            qtd: Number(produto.estoque),
          });
        }
      });

      return novaLista;
    });
  }

  /**
   * Desmarca todos os produtos que estão aparecendo na busca.
   */
  function desmarcarTodosResultados() {
    const codigos = estoque
      .filter((p) =>
        p.descricao
          ?.toLowerCase()
          .includes(buscaProduto.toLowerCase())
      )
      .map((p) => p.codproduto);

    setItens((listaAtual) =>
      listaAtual.filter(
        (item) => !codigos.includes(item.codproduto)
      )
    );
  }

  function selecionarVendedor(v) {
    setVendedorSel(v);
    setBuscaVendedor(v.nome);
  }

  async function confirmar(tipo) {
    if (itens.length === 0) {
      alert("Selecione pelo menos um produto.");
      return;
    }

    if (tipo === "transferir" && !vendedorSel) {
      alert("Selecione o vendedor.");
      return;
    }

    try {
      setLoading(true);

      if (tipo === "transferir") {
        await api.post(
          "v1/estoque/transferir",
          {
            itens,
            codusuario: localStorage.getItem("tempCodUsuario"),
            codfuncionario: vendedorSel.codfuncionario,
            codequipe: localStorage.getItem("tempCodEquipe"),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
            },
          }
        );

        alert("Transferência enviada!");

        atualizarEstoqueLocal(itens, "transferir");

        setModalTransferir(false);
      } else {
        await api.post(
          "v1/estoque/devolver",
          {
            itens,
            codusuario: localStorage.getItem("tempCodUsuario"),
            codfuncionario: localStorage.getItem("tempCodFuncionario"),
            codequipe: localStorage.getItem("tempCodEquipe"),
            tipo: tipoUsuario,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
            },
          }
        );

        alert("Devolução enviada!");

        atualizarEstoqueLocal(itens, "devolver");

        setModalDevolver(false);
      }

      // Limpa os dados após concluir
      setItens([]);
      setBuscaProduto("");
      setVendedorSel(null);
      setBuscaVendedor("");
    } catch (err) {
      console.error(err);
      alert("Erro ao salvar movimentação");
    } finally {
      setLoading(false);
    }
  }

  function atualizarEstoqueLocal(itensMovimentados, tipo) {
    setEstoque((estoqueAtual) =>
      estoqueAtual.map((prod) => {
        const item = itensMovimentados.find(
          (i) => i.codproduto === prod.codproduto
        );

        if (!item) return prod;

        let novaQtd = prod.estoque;

        if (tipo === "transferir") {
          novaQtd = prod.estoque - item.qtd;
        } else {
          novaQtd =
            tipoUsuario === "E"
              ? prod.estoque + item.qtd
              : prod.estoque - item.qtd;
        }

        return {
          ...prod,
          estoque: Math.max(0, novaQtd),
        };
      })
    );
  }

  // Produtos exibidos de acordo com a pesquisa
  const produtosFiltrados = estoque.filter((p) =>
    p.descricao
      ?.toLowerCase()
      .includes(buscaProduto.toLowerCase())
  );

  return (
    <div className="container-fluid py-4">
      <FloatingMenu />

      <h4 className="mb-3 text-center">Estoque</h4>

      <div className="d-flex gap-2 mb-3 justify-content-center flex-wrap">
        {tipoUsuario === "E" && (
          <button
            className="btn btn-primary"
            onClick={() => abrirModal("transferir")}
          >
            Transferir Estoque
          </button>
        )}

        <button
          className="btn btn-warning"
          onClick={() => abrirModal("devolver")}
        >
          {tipoUsuario === "E"
            ? "Devolver p/ Empresa"
            : "Devolver p/ Equipe"}
        </button>
      </div>

      {/* TABELA DESKTOP */}
      <div className="table-responsive d-none d-md-block">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Referência</th>
              <th>Grupo</th>
              <th>Tamanho</th>
              <th>Cor</th>
              <th>Preço</th>
              <th>Qtd</th>
            </tr>
          </thead>

          <tbody>
            {estoque.map((p) => (
              <tr key={p.codproduto}>
                <td>{p.descricao}</td>
                <td>{p.referencia}</td>
                <td>{p.grupo}</td>
                <td>{p.tamanho}</td>
                <td>{p.cor}</td>
                <td>R$ {p.preco}</td>
                <td>{p.estoque}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MOBILE */}
      <div className="d-block d-md-none">
        {estoque.map((p) => (
          <div key={p.codproduto} className="card mb-2">
            <div className="card-body">
              <h6>{p.descricao}</h6>
              <small>Ref: {p.referencia}</small>
              <br />
              Grupo: {p.grupo}
              <br />
              Tam: {p.tamanho}
              <br />
              Cor: {p.cor}
              <br />
              Preço: R$ {p.preco}
              <br />
              Qtd: {p.estoque}
            </div>
          </div>
        ))}
      </div>

      {loading && <Aguarde />}

      {[modalTransferir, modalDevolver].map((aberto, i) => (
        <Modal
          key={i}
          isOpen={aberto}
          onRequestClose={() => {
            setModalTransferir(false);
            setModalDevolver(false);
          }}
          overlayClassName="modal-overlay"
          className="modal-box"
        >
          <div className="modal-header">
            <h5>
              {i === 0
                ? "Transferir p/ Vendedor"
                : tipoUsuario === "E"
                ? "Devolver p/ Empresa"
                : "Devolver p/ Equipe"}
            </h5>

            <button
              className="btn-close"
              onClick={() => {
                setModalTransferir(false);
                setModalDevolver(false);
              }}
            />
          </div>

          <div className="modal-body">
            {/* ============================= */}
            {/* VENDEDORES */}
            {/* ============================= */}

            {i === 0 && (
              <div className="mb-3">
                <label className="form-label fw-bold">
                  Vendedor
                </label>

                <input
                  className="form-control mb-2"
                  placeholder="Buscar vendedor"
                  value={buscaVendedor}
                  onChange={(e) => {
                    setBuscaVendedor(e.target.value);
                    setVendedorSel(null);
                  }}
                />

                {buscaVendedor && !vendedorSel && (
                  <div className="list-group mb-2">
                    {vendedores
                      .filter((v) =>
                        v.nome
                          .toLowerCase()
                          .includes(buscaVendedor.toLowerCase())
                      )
                      .map((v) => (
                        <button
                          type="button"
                          key={v.codfuncionario}
                          className="list-group-item list-group-item-action"
                          onClick={() => selecionarVendedor(v)}
                        >
                          {v.nome}
                        </button>
                      ))}
                  </div>
                )}

                {vendedorSel && (
                  <div className="alert alert-info py-2 mb-0">
                    Vendedor selecionado:{" "}
                    <strong>{vendedorSel.nome}</strong>
                  </div>
                )}
              </div>
            )}

            {/* ============================= */}
            {/* PRODUTOS */}
            {/* ============================= */}

            <div className="produto-selecao-container">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label fw-bold mb-0">
                  Produtos
                </label>

                {itens.length > 0 && (
                  <span className="badge bg-primary">
                    {itens.length} selecionado
                    {itens.length > 1 ? "s" : ""}
                  </span>
                )}
              </div>

              <input
                className="form-control mb-2"
                placeholder="Buscar produto..."
                value={buscaProduto}
                onChange={(e) => setBuscaProduto(e.target.value)}
              />

              {/* BOTÕES DE SELEÇÃO */}
              {produtosFiltrados.length > 0 && (
                <div className="d-flex gap-2 mb-2 flex-wrap">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={selecionarTodosResultados}
                  >
                    Selecionar todos
                  </button>

                  {/* Seleção de quantidade total disponível para devolução à empresa */}
                  {i === 1 && tipoUsuario === "E" && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-success"
                      onClick={selecionarTodosParaDevolucaoTotal}
                    >
                      Devolver quantidade total
                    </button>
                  )}

                  {itens.length > 0 && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={desmarcarTodosResultados}
                    >
                      Desmarcar resultados
                    </button>
                  )}
                </div>
              )}

              {/* LISTA DE PRODUTOS */}
              <div className="produtos-lista">
                {produtosFiltrados.length === 0 ? (
                  <div className="text-muted text-center p-3">
                    Nenhum produto encontrado.
                  </div>
                ) : (
                  produtosFiltrados.map((p) => {
                    const selecionado = produtoSelecionado(
                      p.codproduto
                    );

                    const itemSelecionado = itens.find(
                      (item) =>
                        item.codproduto === p.codproduto
                    );

                    return (
                      <div
                        key={p.codproduto}
                        className={`produto-item ${
                          selecionado
                            ? "produto-item-selecionado"
                            : ""
                        } ${
                          p.estoque <= 0
                            ? "produto-sem-estoque"
                            : ""
                        }`}
                        onClick={() => {
                          if (p.estoque > 0) {
                            alternarProduto(p);
                          }
                        }}
                      >
                        <div className="produto-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={selecionado}
                            disabled={p.estoque <= 0}
                            onChange={() => alternarProduto(p)}
                            onClick={(e) =>
                              e.stopPropagation()
                            }
                          />
                        </div>

                        <div className="produto-info">
                          <div className="produto-descricao">
                            {p.descricao}
                          </div>

                          <div className="produto-detalhes">
                            {p.referencia && (
                              <span>
                                Ref: {p.referencia}
                              </span>
                            )}

                            {p.tamanho && (
                              <span>
                                Tam: {p.tamanho}
                              </span>
                            )}

                            {p.cor && (
                              <span>
                                Cor: {p.cor}
                              </span>
                            )}
                          </div>

                          <small
                            className={
                              p.estoque > 0
                                ? "text-success"
                                : "text-danger"
                            }
                          >
                            Disponível: {p.estoque}
                          </small>
                        </div>

                        {/* QUANTIDADE */}
                        {selecionado && itemSelecionado && (
                          <div
                            className="produto-quantidade"
                            onClick={(e) =>
                              e.stopPropagation()
                            }
                          >
                            <label>Qtd.</label>

                            <input
                              type="number"
                              className="form-control form-control-sm"
                              min="1"
                              max={p.estoque}
                              value={itemSelecionado.qtd}
                              onChange={(e) =>
                                alterarQuantidade(
                                  p.codproduto,
                                  e.target.value
                                )
                              }
                            />
                          </div>
                        )}
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            {/* ============================= */}
            {/* PRODUTOS SELECIONADOS */}
            {/* ============================= */}

            {itens.length > 0 && (
              <div className="produtos-selecionados mt-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">
                    Produtos para lançamento
                  </h6>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={limparProdutos}
                  >
                    Limpar
                  </button>
                </div>

                {itens.map((item) => (
                  <div
                    key={item.codproduto}
                    className="produto-lancamento"
                  >
                    <div>
                      <strong>{item.descricao}</strong>

                      <div className="small text-muted">
                        Quantidade: {item.qtd}
                      </div>
                    </div>

                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={() =>
                        removerItem(item.codproduto)
                      }
                    >
                      ×
                    </button>
                  </div>
                ))}

                <div className="total-itens">
                  <strong>
                    Total de produtos: {itens.length}
                  </strong>

                  <strong>
                    Total de unidades:{" "}
                    {itens.reduce(
                      (total, item) => total + Number(item.qtd),
                      0
                    )}
                  </strong>
                </div>
              </div>
            )}
          </div>

          {/* ============================= */}
          {/* RODAPÉ */}
          {/* ============================= */}

          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={() => {
                setModalTransferir(false);
                setModalDevolver(false);
              }}
            >
              Cancelar
            </button>

            <button
              className="btn btn-primary"
              disabled={
                itens.length === 0 ||
                (i === 0 && !vendedorSel)
              }
              onClick={() =>
                confirmar(
                  i === 0 ? "transferir" : "devolver"
                )
              }
            >
              Confirmar
              {itens.length > 0 &&
                ` (${itens.length})`}
            </button>
          </div>
        </Modal>
      ))}
    </div>
  );
}